import _cloneDeep from 'lodash/cloneDeep'
import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/PromoCode_fortuneWheel'
import themeBase from './_themeBase'

const info = _cloneDeep(baseInfo)
const json = _cloneDeep(baseJson)
const templateID = info.templateID + 4

info.templateID = templateID
info.name = 'New Year\'s:' + info.name
json.templateID = templateID

json.settings = {
  ...json.settings,
  closeButtonColor: '#FFDF00',
}

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#000000',
  backgroundImage: 'url("https://assets.onvocado.com/templates/ny_bg.png")',
}

json.theme = themeBase.theme

// // Modify content items as needed
// json.steps[0].contentItems = json.steps[0].contentItems.map((item) => {
//   if (item.type === 'headline') {
//     item.content.text = 'Black Friday Specials Await!'
//     item.styling.color = 'rgba(255, 255, 255, 1)'
//   }
//   // Add more conditionals for other content item types
//   return item
// })

export { json, info }